module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/motorcycle-storage.jpg";